<template>
  <div>
    <Form :model="searchData" inline>
      <FormItem prop="keyword">
        <Input v-model="searchData.keyword" placeholder="搜索车队名称或ID" class="lx-search-item"></Input>
      </FormItem>
      <FormItem>
        <Checkbox
          :indeterminate="indeterminate"
          :value="checkAll"
          @click.prevent.native="checkAllCompanies"
        >全选</Checkbox>
        <Button type="primary" @click="doSubmit" style="margin-left: 8px">提交</Button>
      </FormItem>
    </Form>

    <div class="company-list">
      <CheckboxGroup v-model="checked" @on-change="handleCheckedChange" class="custom-checkbox">
        <Checkbox
          v-for="item in filteredCompanies"
          :key="item.company_id"
          :label="item.company_id"
          class="company-item"
        >
          <span class="company-id">{{ item.company_id }}</span>
          <span>{{ item.company_name }}</span>
        </Checkbox>
      </CheckboxGroup>
    </div>
  </div>
</template>

<script>
export default {
  name: 'editCompany',
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      searchData: {
        keyword: ''
      },
      companies: [],
      checked: [],
      allCompanyIds: [],
      checkAll: false,
      indeterminate: false,
      loading: false
    }
  },
  computed: {
    filteredCompanies () {
      const keyword = this.searchData.keyword.trim().toLowerCase()
      if (!keyword) {
        return this.companies
      }
      return this.companies.filter(item => {
        const companyId = String(item.company_id)
        const companyName = String(item.company_name || '').toLowerCase()
        return companyId.includes(keyword) || companyName.includes(keyword)
      })
    }
  },
  methods: {
    async getInfo () {
      if (!this.id) {
        return
      }
      const res = await this.$commonFun.postProxy('admin/agent/getAgentCompanies', { id: this.id })
      this.companies = res.data.companies || []
      this.checked = res.data.checked || []
      this.allCompanyIds = res.data.all_company_ids || []
      this.syncCheckStatus()
    },
    syncCheckStatus () {
      if (this.checked.length === 0) {
        this.checkAll = false
        this.indeterminate = false
        return
      }
      if (this.checked.length === this.allCompanyIds.length) {
        this.checkAll = true
        this.indeterminate = false
        return
      }
      this.checkAll = false
      this.indeterminate = true
    },
    handleCheckedChange () {
      this.syncCheckStatus()
    },
    checkAllCompanies () {
      this.checkAll = this.checked.length !== this.allCompanyIds.length
      this.indeterminate = false
      this.checked = this.checkAll ? [...this.allCompanyIds] : []
    },
    async doSubmit () {
      if (this.loading) {
        return
      }
      this.loading = true
      const res = await this.$commonFun.postProxy('admin/agent/editAgentCompany', {
        id: this.id,
        checked: this.checked
      })
      this.loading = false
      this.$commonFun.dealApiResult(res, () => {
        this.$commonFun.successTip(res.msg || '操作成功', () => {
          this.$emit('edit-success')
        })
      })
    }
  },
  mounted () {
    this.getInfo()
  }
}
</script>

<style scoped>
.company-list {
  max-height: 680px;
  overflow-y: auto;
  padding: 8px 0;
}

.company-item {
  display: block;
  margin: 8px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.company-id {
  display: inline-block;
  min-width: 64px;
  margin-right: 8px;
  color: #2d8cf0;
}
</style>
